import { render, staticRenderFns } from "./NamesViewer.vue?vue&type=template&id=1f8b2140&scoped=true&lang=pug"
import script from "./NamesViewer.vue?vue&type=script&lang=js"
export * from "./NamesViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8b2140",
  null
  
)

export default component.exports